import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      document.cookie = `erp_token=${token}; path=/; secure; samesite=lax`;
      api.get('/auth/me')
        .then((res) => setUser(res.data))
        .catch(() => {
          if (!localStorage.getItem('access_token')) {
            localStorage.clear();
          }
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    localStorage.setItem('access_token', res.data.access_token);
    localStorage.setItem('refresh_token', res.data.refresh_token);
    document.cookie = `erp_token=${res.data.access_token}; path=/; secure; samesite=lax`;
    setUser(res.data.user);
    return res.data.user;
  };

  const oidcLogin = async (code, codeVerifier) => {
    const res = await api.post('/auth/oidc/callback', {
      code,
      code_verifier: codeVerifier,
    });
    localStorage.setItem('access_token', res.data.access_token);
    localStorage.setItem('refresh_token', res.data.refresh_token);
    document.cookie = `erp_token=${res.data.access_token}; path=/; secure; samesite=lax`;
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.clear();
    document.cookie = 'erp_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    setUser(null);
    // Выходим и из SSO (единая сессия всех сервисов)
    window.location.href = '/auth/realms/terra/protocol/openid-connect/logout' +
      `?redirect_uri=${encodeURIComponent(window.location.origin + '/login')}`;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, oidcLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
